export const formSubmitButtonCss = {
    margin: 'auto',
    backgroundColor: '#334d66',
    color: 'white',
};
